import styled from '@emotion/styled';

import {
  mobileQuery,
  mobileLandscapeQuery,
  tabletQuery,
  laptopQuery,
  desktopQuery,
} from '../../utils/mediaqueries';

const LogoWrapper = styled.div({
  [mobileQuery]: {
    width: '75%',
    height: '100%',
    marginLeft: '15px',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const WrapperWithLink = LogoWrapper.withComponent('a');

export const UniversityImage = styled.img(
  {
    marginRight: 'auto',

    [mobileQuery]: {
      width: '100%',
    },

    [mobileLandscapeQuery]: {
      width: '80%',
    },

    [tabletQuery]: {
      marginLeft: '30px',
    },

    [laptopQuery]: {
      marginLeft: '55px',
    },

    [desktopQuery]: {
      marginLeft: '70px',
    },
  },
  (props) => ({
    src: props.src,
    alt: props.alt,
  }),
);
